import React, { useContext } from "react";
import { Typography, Button, Tooltip } from "@mui/material";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { navbarMenuItems } from "../../constants";
import CityContext from "../../contexts/CityContext";
import { trackEvent } from "../../hooks/useAnalytics";

export default function MenuLinksDropDown() {
	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
	const open = Boolean(anchorEl);
	const { city } = useContext(CityContext);
	const handleClick = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	// The menu item configuration is stored in constants.ts. The "editParkNavItem" menu item is singled out as it is only active if there is a city selected
	const editParkNavItem = navbarMenuItems.find(
		(item: any) => item.label === "Edit Your Park Data"
	);

	if (city) {
		editParkNavItem.url =
			"https://site.tplgis.org/ParkReviewer/?lid=" + city?.id;
	} else {
		editParkNavItem.url = "#";
	}

	return (
		<>
			<Button
				variant="contained"
				onClick={handleClick}
				aria-haspopup="true"
				aria-expanded={open ? "true" : undefined}
				sx={{ marginRight: "1rem" }}
			>
				<Typography variant="link">Feedback and More Info</Typography>
			</Button>
			<Menu
				id="demo-positioned-menu"
				aria-labelledby="demo-positioned-button"
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "left",
				}}
				transformOrigin={{
					vertical: "top",
					horizontal: "left",
				}}
				sx={{
					width: 300,
				}}
			>
				{/* This code iterates over the menu items and creats one for each. The formatting is different for the email feedback link. The "Edit Your Park Data" item is disabled if no city is selected. */}
				{navbarMenuItems.map((item: any, i: any) => (
					<Tooltip
						key={i}
						title={
							item.label === "Edit Your Park Data" && !city
								? "Select a city to enable this option"
								: ""
						}
						placement="left"
						arrow
					>
						<div>
							<MenuItem
								sx={{
									justifyContent: "flex-start",
									paddingBottom: 0,
									whiteSpace: "unset",
								}}
								disabled={item.label === "Edit Your Park Data" && !city}
								onClick={() => {
									trackEvent("feedback_menu_buttons", item.label);
									window.open(item.url, "_blank");
									setAnchorEl(null);

									if (item.label === "Edit Your Park Data" && city) { 
										trackEvent("park_reviewer", {
											park_reviewer_click: "menu",
											park_reviewer_url: item.url,
										});
									}
								}}
							>
								<Typography variant={item.variant}>{item.label}</Typography>
							</MenuItem>
						</div>
					</Tooltip>
				))}
			</Menu>
		</>
	);
}
